// GENERATED by build-pardus-guard.cjs. SHA256: 516384ed042e75dbecdb7ac703dec7e30dd95bfe4d51a2d95113dbbd5b1b09c0
window.PardusPickupLocations = {
  "pardus-000": {
    "countryCode": "ES",
    "provinceCode": "VI"
  },
  "pardus-001": {
    "countryCode": "ES",
    "provinceCode": "C"
  },
  "pardus-002": {
    "countryCode": "ES",
    "provinceCode": "C"
  },
  "pardus-003": {
    "countryCode": "ES",
    "provinceCode": "OR"
  },
  "pardus-004": {
    "countryCode": "ES",
    "provinceCode": "A"
  },
  "pardus-005": {
    "countryCode": "ES",
    "provinceCode": "A"
  },
  "pardus-006": {
    "countryCode": "ES",
    "provinceCode": "A"
  },
  "pardus-007": {
    "countryCode": "ES",
    "provinceCode": "A"
  },
  "pardus-008": {
    "countryCode": "ES",
    "provinceCode": "A"
  },
  "pardus-009": {
    "countryCode": "ES",
    "provinceCode": "A"
  },
  "pardus-010": {
    "countryCode": "ES",
    "provinceCode": "A"
  },
  "pardus-011": {
    "countryCode": "ES",
    "provinceCode": "AL"
  },
  "pardus-013": {
    "countryCode": "ES",
    "provinceCode": "B"
  },
  "pardus-017": {
    "countryCode": "ES",
    "provinceCode": "BU"
  },
  "pardus-018": {
    "countryCode": "ES",
    "provinceCode": "CA"
  },
  "pardus-019": {
    "countryCode": "ES",
    "provinceCode": "S"
  },
  "pardus-020": {
    "countryCode": "ES",
    "provinceCode": "S"
  },
  "pardus-021": {
    "countryCode": "ES",
    "provinceCode": "S"
  },
  "pardus-022": {
    "countryCode": "ES",
    "provinceCode": "CS"
  },
  "pardus-023": {
    "countryCode": "ES",
    "provinceCode": "CS"
  },
  "pardus-024": {
    "countryCode": "ES",
    "provinceCode": "CS"
  },
  "pardus-025": {
    "countryCode": "ES",
    "provinceCode": "CO"
  },
  "pardus-026": {
    "countryCode": "ES",
    "provinceCode": "CO"
  },
  "pardus-027": {
    "countryCode": "ES",
    "provinceCode": "CO"
  },
  "pardus-029": {
    "countryCode": "ES",
    "provinceCode": "GR"
  },
  "pardus-030": {
    "countryCode": "ES",
    "provinceCode": "GR"
  },
  "pardus-031": {
    "countryCode": "ES",
    "provinceCode": "CR"
  },
  "pardus-032": {
    "countryCode": "ES",
    "provinceCode": "SS"
  },
  "pardus-033": {
    "countryCode": "ES",
    "provinceCode": "SS"
  },
  "pardus-034": {
    "countryCode": "ES",
    "provinceCode": "H"
  },
  "pardus-035": {
    "countryCode": "ES",
    "provinceCode": "H"
  },
  "pardus-036": {
    "countryCode": "ES",
    "provinceCode": "PM"
  },
  "pardus-037": {
    "countryCode": "ES",
    "provinceCode": "PM"
  },
  "pardus-038": {
    "countryCode": "ES",
    "provinceCode": "TF"
  },
  "pardus-039": {
    "countryCode": "ES",
    "provinceCode": "TF"
  },
  "pardus-040": {
    "countryCode": "ES",
    "provinceCode": "GC"
  },
  "pardus-041": {
    "countryCode": "ES",
    "provinceCode": "TF"
  },
  "pardus-042": {
    "countryCode": "ES",
    "provinceCode": "GC"
  },
  "pardus-043": null,
  "pardus-044": {
    "countryCode": "ES",
    "provinceCode": "GC"
  },
  "pardus-045": {
    "countryCode": "ES",
    "provinceCode": "TF"
  },
  "pardus-046": {
    "countryCode": "ES",
    "provinceCode": "J"
  },
  "pardus-047": {
    "countryCode": "ES",
    "provinceCode": "J"
  },
  "pardus-048": {
    "countryCode": "ES",
    "provinceCode": "J"
  },
  "pardus-049": {
    "countryCode": "ES",
    "provinceCode": "J"
  },
  "pardus-050": {
    "countryCode": "ES",
    "provinceCode": "J"
  },
  "pardus-051": {
    "countryCode": "ES",
    "provinceCode": "LO"
  },
  "pardus-052": {
    "countryCode": "ES",
    "provinceCode": "LE"
  },
  "pardus-055": {
    "countryCode": "ES",
    "provinceCode": "M"
  },
  "pardus-056": {
    "countryCode": "ES",
    "provinceCode": "M"
  },
  "pardus-057": {
    "countryCode": "ES",
    "provinceCode": "M"
  },
  "pardus-058": {
    "countryCode": "ES",
    "provinceCode": "M"
  },
  "pardus-059": {
    "countryCode": "ES",
    "provinceCode": "M"
  },
  "pardus-060": {
    "countryCode": "ES",
    "provinceCode": "MA"
  },
  "pardus-061": {
    "countryCode": "ES",
    "provinceCode": "MA"
  },
  "pardus-062": {
    "countryCode": "ES",
    "provinceCode": "MA"
  },
  "pardus-063": {
    "countryCode": "ES",
    "provinceCode": "MA"
  },
  "pardus-064": {
    "countryCode": "ES",
    "provinceCode": "MA"
  },
  "pardus-065": {
    "countryCode": "ES",
    "provinceCode": "MA"
  },
  "pardus-066": {
    "countryCode": "ES",
    "provinceCode": "MU"
  },
  "pardus-067": {
    "countryCode": "ES",
    "provinceCode": "MU"
  },
  "pardus-068": {
    "countryCode": "ES",
    "provinceCode": "MU"
  },
  "pardus-069": {
    "countryCode": "ES",
    "provinceCode": "MU"
  },
  "pardus-070": {
    "countryCode": "ES",
    "provinceCode": "MU"
  },
  "pardus-071": {
    "countryCode": "ES",
    "provinceCode": "NA"
  },
  "pardus-072": {
    "countryCode": "ES",
    "provinceCode": "NA"
  },
  "pardus-073": {
    "countryCode": "ES",
    "provinceCode": "PO"
  },
  "pardus-074": {
    "countryCode": "ES",
    "provinceCode": "PO"
  },
  "pardus-075": {
    "countryCode": "ES",
    "provinceCode": "PO"
  },
  "pardus-076": {
    "countryCode": "ES",
    "provinceCode": "SA"
  },
  "pardus-077": {
    "countryCode": "ES",
    "provinceCode": "SE"
  },
  "pardus-078": {
    "countryCode": "ES",
    "provinceCode": "SE"
  },
  "pardus-079": {
    "countryCode": "ES",
    "provinceCode": "SE"
  },
  "pardus-080": {
    "countryCode": "ES",
    "provinceCode": "SE"
  },
  "pardus-081": {
    "countryCode": "ES",
    "provinceCode": "SE"
  },
  "pardus-082": {
    "countryCode": "ES",
    "provinceCode": "SE"
  },
  "pardus-083": {
    "countryCode": "ES",
    "provinceCode": "V"
  },
  "pardus-084": {
    "countryCode": "ES",
    "provinceCode": "V"
  },
  "pardus-085": {
    "countryCode": "ES",
    "provinceCode": "V"
  },
  "pardus-086": {
    "countryCode": "ES",
    "provinceCode": "V"
  },
  "pardus-087": {
    "countryCode": "ES",
    "provinceCode": "BI"
  },
  "pardus-088": {
    "countryCode": "ES",
    "provinceCode": "BI"
  },
  "pardus-089": {
    "countryCode": "ES",
    "provinceCode": "ZA"
  },
  "pardus-090": {
    "countryCode": "PT",
    "provinceCode": ""
  },
  "pardus-091": {
    "countryCode": "PT",
    "provinceCode": ""
  },
  "pardus-092": {
    "countryCode": "PT",
    "provinceCode": ""
  },
  "pardus-093": {
    "countryCode": "PT",
    "provinceCode": ""
  }
};
